import React from "react";

import classes from "./SquareImageWithLabel.module.scss";
import { Media } from '../Media';
import type { Media as MediaType } from '../../../payload/payload-types';
import { renderTrademarkText } from '../TrademarkText';

export const SquareImageWithLabel = ({ image, label, labelPosition = 'bottomRight' }: { image: MediaType, label: string; labelPosition?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'; }) => {
  return (
    <div className={classes.wrapperDiv}>
      <Media resource={image} alt={image ? image.alt : ''} className={classes.image} imageSize='square' />
      <div className={`${classes.label} ${classes[labelPosition]}`}>
        <span>{renderTrademarkText(label)}</span>
      </div>
    </div>
  );
};

export default SquareImageWithLabel;
